import { createQueryKeys } from '@lukemorales/query-key-factory'

import { searchService } from '@/domain/Search'
import { GetSearchResultsDto } from '@/domain/Search/dtos/get-search-results.dto'

export const search = createQueryKeys('search', {
    searchNative: (dto: GetSearchResultsDto) => ({
        queryKey: [
            'native',
            {
                ...dto,
            },
        ],
        queryFn: async () => await searchService.getSearchResults(dto),
    }),
    searchAlgolia: (query: string) => ({
        queryKey: ['search', 'algolia', query],
        queryFn: () => searchService.getSearchResultsAlgolia(query),
    }),
})
